var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDescendingArrow = function SvgDescendingArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.918.914a.312.312 0 1 1 .625 0zm.533 9.283a.31.31 0 0 1-.441 0L3.02 8.208a.312.312 0 1 1 .443-.442L5.23 9.534l1.768-1.768a.312.312 0 1 1 .442.442zM5.543.914v9.062h-.625V.914z"
  })));
};
export default SvgDescendingArrow;